// extracted by mini-css-extract-plugin
module.exports = {"faqItem":"FaqItem_faqItem__buNCD","faqItem__inner":"FaqItem_faqItem__inner___1n_i","faqItem__dl__inner":"FaqItem_faqItem__dl__inner__gKAd5"};